<template>
    <div>
        <!-- <div class='fw9 mb-3 gray'>Member List</div> -->
        <div v-for="(t, index) in team" :key="'team_'+team.id" >
            <div class='row mt-1'>
                <div class='col-12 col-lg-12'>
                    <h3 class='black'>Equipe</h3>
                </div>
                <div class='col-12 offset-lg-2 col-lg-8'>
                    <team-form-new :teamId="t.id"  />  
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

    props:{
        team:{
            default:()=>[]
        }
    }
}
</script>

<style>

</style>
